/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CredentialPresentation
 */
export interface CredentialPresentation {
    /**
     * 
     * @type {string}
     * @memberof CredentialPresentation
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof CredentialPresentation
     */
    value: string;
    /**
     * 
     * @type {boolean}
     * @memberof CredentialPresentation
     */
    temporary?: boolean;
}

/**
 * Check if a given object implements the CredentialPresentation interface.
 */
export function instanceOfCredentialPresentation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function CredentialPresentationFromJSON(json: any): CredentialPresentation {
    return CredentialPresentationFromJSONTyped(json, false);
}

export function CredentialPresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CredentialPresentation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'value': json['value'],
        'temporary': !exists(json, 'temporary') ? undefined : json['temporary'],
    };
}

export function CredentialPresentationToJSON(value?: CredentialPresentation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'value': value.value,
        'temporary': value.temporary,
    };
}

